import FleetNavbar from '../fleet/FleetNavbar';
import { FleetSidenav } from '../fleet/FleetSidenav';
import AllGroupsProvider from '../providers/AllGroupsProvider';
import AssetsProvider from '../providers/AssetsProvider';
import DashboardWrapper from '../shared/DashboardWrapper';

export function FleetDashboard() {
  return (
    <DashboardWrapper
      navbar={<FleetNavbar />}
      sidenav={<FleetSidenav />}
      providers={
        <>
          <AllGroupsProvider />
          <AssetsProvider />
        </>
      }
      withMarginLeft
    />
  );
}
